<template>
  <div class="container-fluid">
    <h1 class="detail-title">
      <i id="sidebar" class="fa fa-bars sidebar" @click="toggleSidebar"></i>
      Create Data Source
    </h1>
    <div id="card">
      <div class="card-section">
        <popups></popups>  
        <div class="row section-body">
          <div class="col-sm-6 section-property-block">
            <p class="section-property-title">Name</p>
            <input id="datasource-name" type="text" name="name" required/>
          </div>
        </div>
        
        <div class="row section-body">
          <div class="col-sm-3 section-property-block">
            <p class="section-property-title">Data Type</p>
            <select class="section-property" 
              id="datasource-datatype" name="datatype">
              <option v-for="datatype in datatype_options"
                  :value="datatype.value">{{ datatype.label }}
              </option>
            </select>
          </div>

           <div class="col-sm-3 section-property-block">
            <p class="section-property-title">Delivery Date</p>
            <dropdown class="form-group">
              <div class="input-group">
                <input id="datasource-deliverydate" :value="delivery_date" disabled 
                    placeholder="--" type="datetime"/>
                <div class="input-group-btn">
                  <btn class="dropdown-toggle"><i class="glyphicon glyphicon-calendar"></i></btn>
                </div>
              </div>
              <template slot="dropdown">
                <li>
                  <date-picker v-model="delivery_date"/>
                </li>
              </template>
            </dropdown>
          </div>
        </div>
        
        <div class="row section-body">
          <div class="col-sm-3 section-property-block">
            <p class="section-property-title">Curator</p>
            <select class="section-property" 
              id="datasource-curator" name="curator">
              <option v-for="curator in curator_options"
                  :value="curator.id">{{ curator.first_name +' '+curator.last_name }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="card-section">
        <div class="row section-body group-users">
          <div class="col-sm-6 section-property-block">
            <p class="section-property-title">Indicators</p>
            <multi-select v-model="indicators" label-key="name" value-key="id"
              :options="indicator_options" filterable block limit="1"/>
          </div>
        </div>
      </div>

      <div class="card-section sub-section">
        <div class="row section-body button">
          <div class="col-sm-3 section-property-block">
            <btn type="primary" @click="submitDataSource()">Create</btn>
          </div>
        </div>
      </div>  
    </div>    
  </div>
</template>

<script type="text/javascript">
import { mapState, mapGetters } from 'vuex';
import moment from 'moment';
import store from '../../store.js';
import Popups from '../Popups';
import constants from '../../constants'
import { bus } from '../../main';
import { MultiSelect } from 'uiv'

export default {
  data () {
      return {
        errors: [],
        indicators: [],
        delivery_date: null,
        message: {type: 'warning', title: 'Data Source'}
      };
  },
  computed: {
    ...mapGetters([ 'hasErrors', 'getErrors', 'resetErrors' ]),
    ...mapState({
      curator_options: function(state) {
        return state.users;
      },

      datatype_options: function(state){
        return state.acceptedDataSourceTypes;
      },

      indicator_options: function(state){
        return state.indicators;
      }
    }),
  },
  methods: {
    toggleSidebar(){
      bus.$emit('toggle-sidebar');
    },
    
    reset: function() {
      this.errors = [];
      bus.$emit('reset', {});
    },
    
    trimValue: function(value) {
      return (value != undefined || value != null)? value.trim() : value;
    },
    
    showPopup: function(value, type){
      bus.$emit(type, {data: value});
      this.redirect(value.type);
    },
    
    resetTemplate: function() {
      this.tags = [];
      this.clearFields(document.getElementById('card'));
    },
    
    clearFields: function(element) {
      for (var i = 0; i < element.childNodes.length; i++) {
         var e = element.childNodes[i];
         if (e.tagName) switch (e.tagName.toLowerCase()) {
            case 'input':
               switch (e.type) {
                  case "radio":
                  case "checkbox": e.checked = false; break;
                  case "button":
                  case "submit":
                  case "image": break;
                  default: e.value = ''; break;
               }
               break;
            case 'select': e.selectedIndex = 0; break;
            case 'textarea': e.value = ''; break
            default: this.clearFields(e);
         }
      }
    },
    
    createDataSource: async function(data) {
      let failed = constants.message.create.failed;
      let success = constants.message.create.success;
      let response  = await store.dispatch('createDataSource', { data_source: data }); 
      
      if(response != null){
        this.message.type = 'success';
        this.message.content = success;
      } else this.message.content = failed;
      this.showPopup(this.message, 'notification');
    },
    
    submitDataSource: function(){
      this.reset();

      let name = $("#datasource-name").val();
      let data_type = $("#datasource-datatype option:selected").val();
      
      // get selected curator id from curator option list
      let curator = $("#datasource-curator option:selected").val();
      // let curator = this.curator_options.find(curator => curator.id == curator_id)
      
      if (name.length < 1) {
        this.errors.push('This Data Source requires a name!');
      }
      if (this.delivery_date == null) {
        this.errors.push('A valid delivery date is required!');
      } else {
        if (moment().isAfter(this.delivery_date)) {
          this.errors.push('Please enter a valid delivery date!');
        }
      }
      
      if (this.errors.length > 0) this.showPopup({'content': this.errors }, 'alert');
      else {
        this.createDataSource({
          'name': this.trimValue(name),
          'data_type': this.trimValue(data_type),
          'curator': curator,
          'delivery_date': this.delivery_date,
          'indicators': this.indicators,
          'tags': []
        })
      }
    }
  },
  components: {
    Popups,
    MultiSelect
  },
  beforeRouteEnter (to, from, next) {
    store.dispatch('fetchDataSourceAcceptedTypes');
    store.dispatch('fetchUsers');
    store.dispatch('fetchIndicators');
    next();
  },

  beforeDestroy () {
    store.dispatch('resetErrors');
  },
};
</script>

<style scoped lang="scss">
@import "../../css/constants";
input, textarea, select { outline: none; border: none; }

h1.detail-title{
  background-color: #04bafc;
  padding: 20px;
  margin-left: -40px;
  margin-right: -40px;
  color: white;
  height: auto;
  margin-bottom: 25px;
  
  i { 
    cursor: pointer;
    display: none; 
    font-size: 1.1em; 
    margin-top: -4px; 
    vertical-align: middle; 
    text-shadow:  0px 1px 1px rgba(0, 0, 0, 0.1);
    
    &:hover {
      color: #f1f1f1;
    }
  }
}

input:not([disabled]):active,
input:not([disabled]):focus,
input:not([disabled]) {
  width:100%;
  border-bottom: 1px solid #c3c3c3;
}

/* body select.select_box */
select {
  display: block;
  padding: 6px 0px !important;
  max-width: 100%;
  height: auto !important;
  border: none !important;
  border-radius: 0px;
  background: transparent;
  border-bottom: 1px solid #c3c3c3 !important;

  font-size: 16px;
  line-height: 16px !important;
  appearance: none; /* this is must */
  -webkit-appearance: none;
  -moz-appearance: none;
}

/* body select.select_box option */
body select option { padding: 0 4px; }
/* for IE and Edge */
select::-ms-expand { display: none; }
select:disabled::-ms-expand { background: #f60; }
textarea {
    width: 60%;
    max-width: 60%;
    min-width: 60%;
    height: 50px;
    max-height: 50px;
    min-height: 50px;
    border-bottom: 1px solid #c3c3c3;
    padding: 0;
    overflow: auto;
}
.tool-tip{
  display: none;
  color: grey;
  background-color: #ececec;
  border-radius: 4px;
  position:absolute;
  margin-top: -40px;
  width: fit-content;
  padding-top:5px;
  padding-bottom:5px;
  padding-left: 5px;
  padding-right:5px;
  z-index: 100;
}
.tool-tip::after{
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #ececec transparent transparent transparent;
}
.ellipsis {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.section-property:hover{
  display: block;
}
.container-fluid {
    padding: auto;
}
.card-section {
  display: flex;
  flex-direction: column;
}

.card-sub-body {
  margin-top: 20px !important;
  border-top: 1px solid #ddd;
  padding: 25px 0 0 0;
}

.section-body { display: flex; flex-wrap: wrap; }
.sub-section { margin-top: 25px; }
.section-title {
    color: $gray7;
    font-size: 20px;
    line-height: $p20;
    margin-bottom: $p24;
}
.section-property-block {
  margin-right: $p16;
	margin-bottom: $p16;
	// min-width: 140px;
}
.section-property-title {
    position:relative;
    z-index:1;
    color: $gray5;
    text-transform: uppercase;
    margin-bottom: $p16;
    font-size: 14px;
    line-height: $p14;
}
.section-property-container {
  height: $p32;
}
.section-property {
    color: #7b7b7b;
    border:none;
    word-wrap: break-word;
    cursor: pointer;
    width: 100%;
    font-size: 14px;
}
.detail-card-body{
    background-color: white;

}
@media (min-width: 576px){
  .col-sm-2 {
    max-width: 15.666667%;
  }
}
//Reset Grid
.col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4,
.col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-md-1, .col-md-10,
.col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6,
.col-md-7, .col-md-8, .col-md-9, .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12,
.col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8,
.col-sm-9, .col-xs-1, .col-xs-10, .col-xs-11, .col-xs-12, .col-xs-2, .col-xs-3,
.col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9 {
  padding: 0;
}
//Reset row
.row {
  margin: 0;
}
.plus{
  border: 1px solid #cfcfcf;
  height: 35px;
  width: 35px;
  border-radius: 50%;
  display: flex;
  margin-top: 5px;
  cursor: pointer;
  margin-top: 30px;
  margin-left: 10px;
}
.plus > img{
  margin: auto;
}

  button.save {
    width: 100px;
    height: $p32;
    border: 1px solid $gray4;
    border-radius: 4px;
    background-color: white;
    font-size: $p14;
    color:grey;
    &:focus {
      outline: none;
    }
  }
  
  @media only screen and (min-width: 768px) {
    /* For mobile phones: */
    h1.detail-title {
      padding-left: 45px;
    }
  }

  @media only screen and (min-width: 468px) and (max-width: 768px) {
    /* For mobile phones: */
    h1.detail-title {
      padding-left: 45px;
      i { display: inline-block; margin-right: 15px;  }
    }
  }

  @media only screen and (max-width: 467px) {
    /* For mobile phones: */
    h1.detail-title {
      padding-left: 45px;
      i { display: inline-block; margin-right: 15px; }
    } 
  }
</style>




// WEBPACK FOOTER //
// src/components/dataSource/CreateDataSource.vue